/** Situações da entidade UnidadeNegocio */
export interface UnidadeNegocioSituacao {
    id: number,
    nome: string;
}

export const unidadeNegocioAtiva: UnidadeNegocioSituacao = {id: 1, nome: 'Ativa'};
export const unidadeNegocioInativa: UnidadeNegocioSituacao = {id: 2, nome: 'Inativa'};

export const unidadeNegocioSituacoes: UnidadeNegocioSituacao[] = [
    unidadeNegocioAtiva,
    unidadeNegocioInativa
];
